
import { filterMatchesByOddsRange } from './helpers';

/**
 * Calculate profit/loss for Laying Over 2.5 goals bets
 */
export const calculateOver25LayProfitForRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): number => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let profitLoss = 0;
  const layMarkup = 0.1;
  
  matchesInRange.forEach(match => {
    // Get the over 2.5 goals odds (B365>2.5)
    const over25Odds = typeof match['B365>2.5'] === 'string' 
      ? parseFloat(match['B365>2.5']) 
      : match['B365>2.5'];
      
    if (!isNaN(over25Odds)) {
      // Calculate total goals in the match
      const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
      const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
      const totalGoals = homeGoals + awayGoals;
      
      if (totalGoals > 2.5) {
        // Lay bet loses - we pay out at the lay odds
        const layOdds = over25Odds + layMarkup;
        profitLoss -= (layOdds - 1);
      } else {
        // Lay bet wins - we collect the stake
        profitLoss += 1;
      }
    }
  });
  
  return profitLoss;
};

/**
 * Calculate profit/loss for Laying Under 2.5 goals bets
 */
export const calculateUnder25LayProfitForRange = (
  matches: any[], 
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away'
): number => {
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let profitLoss = 0;
  const layMarkup = 0.1;
  
  matchesInRange.forEach(match => {
    // Get the under 2.5 goals odds (B365<2.5)
    const under25Odds = typeof match['B365<2.5'] === 'string' 
      ? parseFloat(match['B365<2.5']) 
      : match['B365<2.5'];
      
    if (!isNaN(under25Odds)) {
      // Calculate total goals in the match
      const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
      const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
      const totalGoals = homeGoals + awayGoals;
      
      if (totalGoals < 2.5) {
        // Lay bet loses - we pay out at the lay odds
        const layOdds = under25Odds + layMarkup;
        profitLoss -= (layOdds - 1);
      } else {
        // Lay bet wins - we collect the stake
        profitLoss += 1;
      }
    }
  });
  
  return profitLoss;
};

/**
 * Get Over 2.5 lay profit/loss breakdown
 */
export const getOver25LayProfitBreakdown = (
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away',
  matchesParam?: any[]
): { wins: number, losses: number } => {
  const matches = matchesParam || [];
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let winnings = 0;
  let lossAmount = 0;
  const layMarkup = 0.1;
  
  matchesInRange.forEach(match => {
    const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
    const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
    const totalGoals = homeGoals + awayGoals;
    
    const over25Odds = typeof match['B365>2.5'] === 'string' 
      ? parseFloat(match['B365>2.5']) 
      : match['B365>2.5'];
      
    if (!isNaN(over25Odds)) {
      const layOdds = over25Odds + layMarkup;
      
      if (totalGoals > 2.5) {
        // Lay bet loses - we pay out at the lay odds
        lossAmount += (layOdds - 1);
      } else {
        // Lay bet wins - we collect the stake
        winnings += 1;
      }
    }
  });
  
  return { wins: winnings, losses: lossAmount };
};

/**
 * Get Under 2.5 lay profit/loss breakdown
 */
export const getUnder25LayProfitBreakdown = (
  range: { min: number, max: number }, 
  oddsType: 'home' | 'away',
  matchesParam?: any[]
): { wins: number, losses: number } => {
  const matches = matchesParam || [];
  const matchesInRange = filterMatchesByOddsRange(matches, range, oddsType);
  
  let winnings = 0;
  let lossAmount = 0;
  const layMarkup = 0.1;
  
  matchesInRange.forEach(match => {
    const homeGoals = typeof match.FTHG === 'string' ? parseInt(match.FTHG) : match.FTHG || 0;
    const awayGoals = typeof match.FTAG === 'string' ? parseInt(match.FTAG) : match.FTAG || 0;
    const totalGoals = homeGoals + awayGoals;
    
    const under25Odds = typeof match['B365<2.5'] === 'string' 
      ? parseFloat(match['B365<2.5']) 
      : match['B365<2.5'];
      
    if (!isNaN(under25Odds)) {
      const layOdds = under25Odds + layMarkup;
      
      if (totalGoals < 2.5) {
        // Lay bet loses - we pay out at the lay odds
        lossAmount += (layOdds - 1);
      } else {
        // Lay bet wins - we collect the stake
        winnings += 1;
      }
    }
  });
  
  return { wins: winnings, losses: lossAmount };
};
